import msg from "components/string-table";
import { Section } from "main";

import styles from "./WorkExperience.module.css";

type EditableWorkExperience =
  | {
      isEditable: false;
    }
  | {
      isEditable: true;
      onEditWorkExperience: () => void;
    };

export type Experience = {
  id: number;
  endDate?: string;
  organization: string;
  role: string;
  startDate: string;
  tags: ExperienceTagKey[];
  type: ExperienceTypeKey;
};

export type WorkExperienceProps = {
  editable?: EditableWorkExperience;
  experiences?: Experience[];
};

export function WorkExperience(props: WorkExperienceProps) {
  const { editable, experiences } = props;

  return (
    <Section
      onEditClick={editable?.isEditable ? editable.onEditWorkExperience : undefined}
      title={msg("SUB_PROFILE_RELEVANT_WORK_EXPERIENCE_HEADER")}
    >
      <div>
        {experiences && experiences.length > 0 ? (
          <ul className={styles.experienceContentList}>
            {experiences.map((exp) => {
              const startDate = new Date(exp.startDate);
              const endDate = new Date(exp?.endDate || "");
              return (
                <li key={exp.id} className={styles.experienceContentListItem}>
                  <div className={styles.experienceContent}>
                    <div className={styles.experienceContentDate}>
                      <span>
                        {`${startDate.getMonth() + 1}/${startDate.getFullYear()}`}
                        {`${
                          exp.endDate
                            ? ` - ${endDate.getMonth() + 1}/${endDate.getFullYear()}`
                            : " - Present"
                        }`}
                      </span>
                    </div>
                    <div className={styles.experienceContentInfo}>
                      <div>
                        <span
                          style={{ fontWeight: "var(--swing-font-semibold)" }}
                        >{`${exp.organization}`}</span>
                        <span>, {exp.role}</span>
                      </div>
                      <div
                        className={styles.experienceContentRole}
                        style={{ fontStyle: "italic" }}
                      >{`${ExperienceType[exp.type]}, (${exp.tags.map((tag, idx, array) =>
                        idx !== 0 && idx <= array.length - 1
                          ? ` ${ExperienceTag[tag]}`
                          : ExperienceTag[tag],
                      )})`}</div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <span className={styles.noExperience}>
            {editable?.isEditable
              ? msg("SUB_PROFILE_RELEVANT_WORK_EXPERIENCE_EDIT_EMPTY")
              : msg("SUB_PROFILE_NO_INFORMATION")}
          </span>
        )}
      </div>
    </Section>
  );
}

export const ExperienceTag = {
  EXP_TAG_K_5: "K-5",
  EXP_TAG_ADULT: "Adult",
  EXP_TAG_PRE_K: "Pre-K",
  EXP_TAG_9_12: "9-12",
  EXP_TAG_6_8: "6-8",
} as const;

export type ExperienceTagKey = keyof typeof ExperienceTag;

export const ExperienceType = {
  SUBSTITUTE_TEACHER: "Substitute Teacher",
  ADMINISTRATOR: "Administrator",
  CLASSROOM_LEAD: "Classroom Lead",
  SMALL_GROUP_INSTRUCTION: "Small Group Instruction",
  ONE_ON_ONE: "One on One",
  CLASSROOM_SUPPORT: "Classroom Support",
} as const;

export type ExperienceTypeKey = keyof typeof ExperienceType;
